<div class="lv-artefact-container lv-component"
     [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <ng-container *ngIf="expansionPanel">
    <mat-expansion-panel (opened)="expansionPanelOpenState = true"
                         (closed)="expansionPanelOpenState = false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div *ngIf="uiArtefakt?.Titel">
            <lv-label-tooltip class="lv-label-tooltip-align-items-centered" [label]="uiArtefakt.Titel"
                              [labelSymbol]="nestedSymbol"
                              [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                              [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"
                              (infotextCollapsableChange)="infotextCollapsableChange($event)"></lv-label-tooltip>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container *ngTemplateOutlet="absatzContent"></ng-container>
    </mat-expansion-panel>
  </ng-container>

  <ng-container *ngIf="!expansionPanel">
    <ng-container *ngTemplateOutlet="absatzContent"></ng-container>
  </ng-container>


  <ng-template #absatzContent>
    <div class="lv-artefact"
         [ngClass]="[!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung,
                  !!uiArtefakt?.TextAusrichtung ? uiArtefakt?.TextAusrichtung : textAusrichtung]">
      <div *ngIf="!expansionPanel" class="lv-absatz-titel">
        <div class="lv-absatz-titel-label-tooltip" *ngIf="uiArtefakt?.Titel">
          <lv-label-tooltip class="lv-label-tooltip-align-items-centered" [label]="uiArtefakt.Titel"
                            [labelSymbol]="nestedSymbol"
                            [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                            [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"
                            (infotextCollapsableChange)="infotextCollapsableChange($event)"></lv-label-tooltip>
        </div>
      </div>
      <lv-info-text-tooltip-collapsable [showInfotext]="showInfotextCollapsable"
                                        [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"></lv-info-text-tooltip-collapsable>
      <ng-container *ngIf="!!uiArtefakt.Text">
        <lv-label-tooltip [label]="uiArtefakt.Text"></lv-label-tooltip>
      </ng-container>
      <lv-infotext-permanent
          [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
      <lv-uiartefakt-container [uiArtefakte]="uiArtefakt.UIArtefakt"></lv-uiartefakt-container>
    </div>
  </ng-template>
</div>
